/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Section_HistoryInputs */

const vi_cdo_section_history = /** @type {(inputs: Cdo_Section_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch sử trạng thái`)
};

/**

* @param {Cdo_Section_HistoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_section_history = /** @type {((inputs?: Cdo_Section_HistoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Section_HistoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_section_history(inputs)
});